export const formatToFormat = (value: string, format: string) => {

if(!value) return "";
    let formattedValue = '';
    let formatIndex = 0;
    let valueIndex = 0;

    while (formatIndex < format.length && valueIndex < value.length) {
        if (format[formatIndex] === '#') {
            // Ignoruje niepasujące znaki w wartości wejściowej
            while (valueIndex < value.length && !/[a-zA-Z0-9]/.test(value[valueIndex])) {
                valueIndex++;
            }
            if (valueIndex < value.length) {
                formattedValue += value[valueIndex];
                valueIndex++;
            }
        } else {
            formattedValue += format[formatIndex];
        }
        formatIndex++;
    }

    return formattedValue;
};
